import { extendTheme } from '@chakra-ui/react';

const config = {
  initialColorMode: 'system',
  useSystemColorMode: true,
};

const theme = extendTheme({
  config,
  colors: {
    brand: {
      50: '#E6F6FF',
      100: '#BAE3FF',
      200: '#7CC4FA',
      300: '#47A3F3',
      400: '#2186EB',
      500: '#0967D2',
      600: '#0552B5',
      700: '#03449E',
      800: '#01337D',
      900: '#002159',
    },
    coolGray: {
      50: '#F5F7FA',
      100: '#E4E7EB',
      200: '#CBD2D9',
      300: '#9AA5B1',
      400: '#7B8794',
      500: '#616E7C',
      600: '#52606D',
      700: '#3E4C59',
      800: '#323F4B',
      900: '#1F2933',
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'coolGray.50',
        color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'coolGray.800',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: (props) => ({
        _hover: {
          bg: props.colorMode === 'dark' ? 'gray.700' : 'coolGray.100',
        },
      }),
      variants: {
        solid: (props) => ({
          bg: props.colorMode === 'dark' ? 'brand.500' : 'brand.400',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'brand.600' : 'brand.500',
          },
        }),
        ghost: (props) => ({
          color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'coolGray.700',
          _hover: {
            bg: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.100',
          },
        }),
      },
    },
    Card: {
      baseStyle: (props) => ({
        container: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          boxShadow: props.colorMode === 'dark' ? '0 2px 4px rgba(0,0,0,0.2)' : '0 2px 4px rgba(0,0,0,0.05)',
        },
      }),
    },
    Navbar: {
      baseStyle: (props) => ({
        container: {
          bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
          borderBottom: '1px solid',
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.200',
        },
      }),
    },
    Table: {
      baseStyle: (props) => ({
        th: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'coolGray.50',
          color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'coolGray.700',
        },
        td: {
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.200',
        },
      }),
    },
    Modal: {
      baseStyle: (props) => ({
        dialog: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
        },
      }),
    },
    Menu: {
      baseStyle: (props) => ({
        list: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.200',
        },
        item: {
          _hover: {
            bg: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.50',
          },
        },
      }),
    },
    Input: {
      baseStyle: (props) => ({
        field: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.200',
          _hover: {
            borderColor: props.colorMode === 'dark' ? 'whiteAlpha.300' : 'coolGray.300',
          },
          _focus: {
            borderColor: props.colorMode === 'dark' ? 'brand.400' : 'brand.500',
            boxShadow: `0 0 0 1px ${props.colorMode === 'dark' ? 'brand.400' : 'brand.500'}`,
          },
        },
      }),
    },
    Select: {
      baseStyle: (props) => ({
        field: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.200',
        },
      }),
    },
    Badge: {
      baseStyle: (props) => ({
        container: {
          bg: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'coolGray.100',
          color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'coolGray.700',
        },
      }),
    },
  },
});

export { theme }; 